import { Trace } from '../../../domain/Trace'
import { TraceSummary } from '../../../domain/TraceSummary'
import { xhprofCompactGraph } from '../../../xhprof/XhprofCompactGraph'
import { generateXhprofReport } from '../../../xhprof/XhprofReportGenerator'
import { FULFILLED } from '../action-helper'
import { FETCH_TRACE, FETCH_TRACE_HISTORY } from './actions'
import { TraceState } from './TraceState'

const initialState: TraceState = {
    byId: {},
    summariesById: {},
    historySummaryIds: [],
    loaded: {},
    historyLoaded: false,
}

export const traceReducer = (state: TraceState = initialState, action: any): TraceState => {
    switch (action.type) {
        case FULFILLED(FETCH_TRACE): {
            let loadedTrace = false

            let trace: Trace = {
                ...action.payload.data,
            }

            if (trace.rawData && 'main()' in trace.rawData) {
                const xhprofReport = generateXhprofReport(trace.rawData)
                const xhprofReportCompact = { ...xhprofReport, data: xhprofCompactGraph(xhprofReport.data, 90) }

                trace = {
                    ...trace,
                    xhprofReport,
                    xhprofReportCompact,
                }

                loadedTrace = true
            }

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [trace.id]: trace,
                },
                loaded: {
                    ...state.loaded,
                    [trace.id]: loadedTrace,
                },
            }
        }
        case FULFILLED(FETCH_TRACE_HISTORY): {
            const summariesById = { ...state.summariesById }
            action.payload.profiles.forEach((profile: TraceSummary) => {
                summariesById[profile.id] = profile
            })

            return {
                ...state,
                summariesById,
                historySummaryIds: action.payload.profiles.map(profile => profile.id),
                historyLoaded: true,
            }
        }
        default:
            return state
    }
}
